import { Icon } from "@material-ui/core";
import React from "react";
import i18n from "Translations/i18n";

import styles from "./PdfViewer.scss";

interface IProps {
    src: string;
}

const PdfViewer: React.FunctionComponent<IProps> = (props: IProps) => (
    <div className={styles.pdfViewer}>
        <button onClick={() => window.open(props.src)}>
            <Icon className={styles.withIcon}>open_in_new</Icon>
            {i18n.t("common.open")}
        </button>
        <iframe src={props.src} frameBorder="0" />    
    </div>
);

export default PdfViewer;


// WEBPACK FOOTER //
// ./src/Components/Common/PdfViewer/PdfViewer.tsx